<div id="queue-wrapper">
  <div class="container">
    <app-search-field></app-search-field>
  </div>
  <hr/>
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</div>
